<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark dense>
            <v-toolbar-title>Sentidos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-toolbar-items>
                  <v-btn dark text v-on="on">
                    Nuevo
                  </v-btn>
                </v-toolbar-items>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.nombre" label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" color="yellow darken-2" @click.native="editSentido()" :disabled="!valid" :loading="loading" class="white--text">Actualizar</v-btn>
                          <v-btn v-else color="yellow darken-2" @click.native="addSentido(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <!-- <v-card-title>
            <v-row>
              <v-col cols="12" md="9">
                <v-text-field
                  label="Filtrar por Sentido"
                  v-model="nombre_sentido"
                  clearable
                  @change="getSentidos()"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-title> -->

          <v-data-table
            :headers="headers"
            :items="listSentidos"
            item-key="user"
            class="elevation-1"
            light
            actions
            :loading="loading"
            :page.sync="page"
            :items-per-page="per_page_table"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:item.action="{ item }">
              <v-icon color="orange"  class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon v-if="!item.deleted_at" color="red"  @click="deleteSentido(item)">mdi-close</v-icon>
            </template>
            <template v-slot:item.activo="{ item }">
              <v-icon
                  v-if="!item.deleted_at"
                  class="mr-2"
                  color="green"
              >mdi-check-bold</v-icon>
              <v-icon
                  v-else
                  class="mr-2"
                  color="grey"
              >mdi-minus</v-icon>
            </template>
          </v-data-table>
          <div class="text-center pt-2" v-if="pagination.total > 1">
            <v-pagination v-model="pagination.current" :length="pagination.total" :total-visible='7' @input="onPageChange"></v-pagination>
          </div>
          <div class="text-center pt-2" v-if="listSentidos.length > itemsPerPage">
            <v-pagination v-model="page" :length="pageCount" :total-visible='7'></v-pagination>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      nombre_sentido:'',
      activo: true,
      valid: true,
      dialog: false,
      loading:false,
      pagination: {
        current: 1,
        total: 0
      },
      per_page_table: 20,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      listSentidos: [],
      // show: false,
      headers: [
        { text: 'Sentido', value: 'nombre', sortable: false },
        { text: 'Activo', value: 'activo', sortable: true },
        { text: 'Acciones', value: 'action', sortable: false, width: '9%' }
      ],
      editedIndex: -1,
      editedItem: {
        nombre:'',
      },
      defaultItem: {
        nombre:'',
      },
      message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
    }
  },
  created() {
    this.$store.commit("SET_LAYOUT", "dashboard-layout");
  },
  computed: {
    ...mapGetters([
    //  "listMaterias",
    ]),
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Sentido' : 'Editar Sentido'
    },
  },
  mounted() {
    this.getSentidos();
    //this.getMaterias();
  },
  watch: {
    nombre_sentido: function (val) {
      this.pagination.current = 1;
      if(!val){
        this.pagination.current = 1;
        // this.nombre_sentido = '',
        this.getSentidos()
      }
    },
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    onPageChange() {
      this.getSentidos();
    },
    getSentidos() {
      this.loading = true;
      console.log(this.nombre_sentido);
      // this.$store.dispatch("GET_DELITOS", { url: "/sentidos"}).then((response) => {
      this.$store.dispatch("GET_SENTIDOS", { url: "/sentidos?page=" + this.pagination.current,
        // data: {
        //   nombre_sentido: this.nombre_sentido,
        // }
      }).then((response) => {
        // console.log(response.data.data.sentidos.current_page);
        this.loading = false;
        this.listSentidos = response.data.data.sentidos;
        this.pagination.current = response.data.data.sentidos.current_page;
        this.pagination.total = response.data.data.sentidos.last_page;
        this.per_page_table = response.data.data.sentidos.per_page;
      })
      .catch(err => {
        console.log(err);
      });
    },
    editItem (item) {
      this.editedIndex = this.listSentidos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      if (this.editedItem.deleted_at) this.activo = false
      else this.activo = true
      this.dialog = true
    },
    addSentido(item){
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch("SAVE_SENTIDO",  { url: "/sentido", data: item } ).then(response => {
          this.close ();
          this.$swal({
            icon: 'success',
            title: 'Sentido guardado correctamente',
            confirmButtonText: "Aceptar"
          })
          this.getSentidos();
        })
        .catch(error => {
          console.log(error);
        });
      }
    },
    editSentido(){
      if (this.$refs.form.validate()) {
        this.loading = true;
        var data = {};
        data.nombre = this.editedItem.nombre
        data.activo = this.activo
        this.$store.dispatch("EDIT_SENTIDO",  { url: "/sentido/" + this.editedItem.id, data: data} ).then(response => {
          this.$swal({
            icon: 'success',
            title: 'Sentido actualizado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.close();
          this.getSentidos();
        })
        .catch(error => {
          console.log(error);
        });
      }
    },
    deleteSentido(item){
      this.$swal({
        title: '¿Desea eliminar Sentido "' + item.nombre + '"?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.$store.dispatch("DELETE_SENTIDO",  { url: "/sentido/" + item.id } ).then(res => {
            Swal.fire({
              icon: 'success',
              title: 'Sentido eliminado correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getSentidos();
          })
          .catch(err => {
            console.log(err);
          });
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },
  }
}
</script>
